import QueryParams from '~/services/QueryParams';
import sessionStorage from '~/services/storage/sessionStorage';

const UTM_KEY = 'utm_medium';
const SOURCE_KEY = 'source';
const SESSION_STORAGE_KEY = 'source';
const EMAIL_ANALYTICS_KEY = 'email';

type Source = 'email' | 'pwa' | 'web' | string;

export const getSource = (): Source => {
  const sourceFromStorage = sessionStorage.getByKey(
    SESSION_STORAGE_KEY,
  ) as Source;
  const utmFromQueryParams = QueryParams.getQueryParam(UTM_KEY);
  const sourceFromQueryParams = QueryParams.getQueryParam(SOURCE_KEY);

  if (utmFromQueryParams === EMAIL_ANALYTICS_KEY) {
    return utmFromQueryParams;
  } else if (sourceFromQueryParams) {
    return sourceFromQueryParams;
  } else if (sourceFromStorage) {
    return sourceFromStorage;
  } else {
    return 'web';
  }
};

export const saveSource = (source: Source): void => {
  sessionStorage.setByKey(SESSION_STORAGE_KEY, source);
};
